import { signin } from "./signin";
import { signup } from "./signup";
import { summary } from "./summary";
import { content } from "./content";

/** Client da API de cursos (`/v3/courses`). Exposto em `GZIntegracoes.v1.cursos`. */
export const cursos = {
  signin,
  signup,
  summary,
  content,
};

export { CoursesApiError } from "./types";
export type {
  Course,
  CourseListResponse,
  SigninParams,
  SigninResult,
  SignupParams,
  SignupResult,
  SummaryParams,
  ContentParams,
} from "./types";
